export const extractFilenameFromBase64 = (base64String: string) => {
  if (!base64String) return 'No file chosen';
  if (base64String && base64String.includes('data:image')) {
    const mimeType = base64String.match(/data:image\/([a-zA-Z0-9]+);base64,/);

    if (mimeType && mimeType[1]) {
      const extension = mimeType[1];
      const filename = `image_${Date.now()}.${extension}`;
      return filename;
    }
  }

  return 'image_unknown.png';
};
